import { render, staticRenderFns } from "./QuotedMessageV2026.vue?vue&type=template&id=57b66ef6&scoped=true"
import script from "./QuotedMessageV2026.vue?vue&type=script&lang=js"
export * from "./QuotedMessageV2026.vue?vue&type=script&lang=js"
import style0 from "./QuotedMessageV2026.vue?vue&type=style&index=0&id=57b66ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b66ef6",
  null
  
)

export default component.exports